"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Companies = void 0;
const companiesGetCompanyDetailsByNameCompaniesCompanyNamePost_js_1 = require("../funcs/companiesGetCompanyDetailsByNameCompaniesCompanyNamePost.js");
const companiesGetCompanyDetailsCompaniesCompanyNumberGet_js_1 = require("../funcs/companiesGetCompanyDetailsCompaniesCompanyNumberGet.js");
const companiesGetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGet_js_1 = require("../funcs/companiesGetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGet.js");
const companiesGetPersonsWithSignificantControlCompaniesCompanyNumberPersonsWithSignificantControlGet_js_1 = require("../funcs/companiesGetPersonsWithSignificantControlCompaniesCompanyNumberPersonsWithSignificantControlGet.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class Companies extends sdks_js_1.ClientSDK {
    /**
     * Get Company Details By Name
     *
     * @remarks
     * Get the details of a company from Companies House using a company name.
     */
    async getCompanyDetailsByNameCompaniesCompanyNamePost(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, companiesGetCompanyDetailsByNameCompaniesCompanyNamePost_js_1.companiesGetCompanyDetailsByNameCompaniesCompanyNamePost)(this, security, request, options));
    }
    /**
     * Get Company Details
     *
     * @remarks
     * Get the details of a company from Companies House using a company number.
     */
    async getCompanyDetailsCompaniesCompanyNumberGet(security, companyNumber, options) {
        return (0, fp_js_1.unwrapAsync)((0, companiesGetCompanyDetailsCompaniesCompanyNumberGet_js_1.companiesGetCompanyDetailsCompaniesCompanyNumberGet)(this, security, companyNumber, options));
    }
    /**
     * Get Persons With Significant Control By Id
     *
     * @remarks
     * Get details of a person using their Person ID from the Companies House Persons with Significant Control dataset.
     *
     * If a person has significant control over multiple companies, the response will include the person for each company.
     */
    async getPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGet(security, personId, options) {
        return (0, fp_js_1.unwrapAsync)((0, companiesGetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGet_js_1.companiesGetPersonsWithSignificantControlByIdCompaniesPersonsWithSignificantControlPersonIdGet)(this, security, personId, options));
    }
    /**
     * Get Persons With Significant Control
     *
     * @remarks
     * Get a recursive array of people who have significant control over a company.
     *
     * The people with direct control will appear in the first array, with people with indirect control coming
     * afterwards.
     *
     * Where a company has significant control, the people of that company are looked up and added to an array in the next
     * level.
     *
     * The array is organized by control level, where:
     *
     * - Index 0 contains an array of people with primary control
     * - Index 1 contains an array of people with secondary control
     * - Index 2 contains an array of people with tertiary control
     *
     * And so on.
     *
     * Each array can be empty if there are no people at that control level.
     */
    async getPersonsWithSignificantControlCompaniesCompanyNumberPersonsWithSignificantControlGet(security, companyNumber, options) {
        return (0, fp_js_1.unwrapAsync)((0, companiesGetPersonsWithSignificantControlCompaniesCompanyNumberPersonsWithSignificantControlGet_js_1.companiesGetPersonsWithSignificantControlCompaniesCompanyNumberPersonsWithSignificantControlGet)(this, security, companyNumber, options));
    }
}
exports.Companies = Companies;
//# sourceMappingURL=companies.js.map